const rolesSpecialtiesSelectorTranslations = {
    en: {
        addTrigger: 'Add role / speciality',
        addPanelTitle: 'Add role / speciality',
        editPanelTitle: 'Edit role / speciality',
        rolePlaceholder: 'Select a role',
        specialtyPlaceholder: 'Select specialities',
        anyRole: 'Any role',
        anySpecialty: 'Any speciality',
        unknownRole: 'Unknown role',
        unknownSpecialty: 'Unknown speciality',
        add: 'Add',
        save: 'Save',
        cancel: 'Cancel',
        done: 'Done',
        remove: 'Remove',
        duplicateError: 'This role / speciality is already added'
    },
    no: {
        addTrigger: 'Legg til rolle / spesialitet',
        addPanelTitle: 'Legg til rolle / spesialitet',
        editPanelTitle: 'Rediger rolle / spesialitet',
        rolePlaceholder: 'Velg en rolle',
        specialtyPlaceholder: 'Velg spesialiteter',
        anyRole: 'Alle roller',
        anySpecialty: 'Alle spesialiteter',
        unknownRole: 'Ukjent rolle',
        unknownSpecialty: 'Ukjent spesialitet',
        add: 'Legg til',
        save: 'Lagre',
        cancel: 'Avbryt',
        done: 'Ferdig',
        remove: 'Fjern',
        duplicateError: 'Denne rollen / spesialiteten er allerede lagt til'
    },
    sv: {
        addTrigger: 'Lägg till roll / specialitet',
        addPanelTitle: 'Lägg till roll / specialitet',
        editPanelTitle: 'Redigera roll / specialitet',
        rolePlaceholder: 'Välj en roll',
        specialtyPlaceholder: 'Välj specialiteter',
        anyRole: 'Alla roller',
        anySpecialty: 'Alla specialiteter',
        unknownRole: 'Okänd roll',
        unknownSpecialty: 'Okänd specialitet',
        add: 'Lägg till',
        save: 'Spara',
        cancel: 'Avbryt',
        done: 'Klar',
        remove: 'Ta bort',
        duplicateError: 'Denna roll / specialitet är redan tillagd'
    }
};

export default rolesSpecialtiesSelectorTranslations;
